/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateLinkRequest,
    CreateLinkResponse,
    EditLinkRequest,
    ExecuteActionRequest,
    GetLinkResponse,
    PatchLinkRequest,
} from '../models';

export interface LinksApiControllerCreateLinkRequest {
    createLinkRequest: CreateLinkRequest;
}

export interface LinksApiControllerEditLinkRequest {
    linkId: string;
    editLinkRequest: EditLinkRequest;
}

export interface LinksApiControllerExecuteActionRequest {
    linkId: string;
    executeActionRequest: ExecuteActionRequest;
}

export interface LinksApiControllerExecuteCampaignActionRequest {
    campaignId: string;
    executeActionRequest: ExecuteActionRequest;
}

export interface LinksApiControllerGetLinkRequest {
    linkId: string;
}

export interface LinksApiControllerPatchLinkRequest {
    linkId: string;
    patchLinkRequest: PatchLinkRequest;
}

/**
 * 
 */
export class LinksApi extends runtime.BaseAPI {

    /**
     */
    async linksApiControllerCreateLinkRaw(requestParameters: LinksApiControllerCreateLinkRequest): Promise<runtime.ApiResponse<CreateLinkResponse>> {
        if (requestParameters.createLinkRequest === null || requestParameters.createLinkRequest === undefined) {
            throw new runtime.RequiredError('createLinkRequest','Required parameter requestParameters.createLinkRequest was null or undefined when calling linksApiControllerCreateLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createLinkRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async linksApiControllerCreateLink(requestParameters: LinksApiControllerCreateLinkRequest): Promise<CreateLinkResponse> {
        const response = await this.linksApiControllerCreateLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async linksApiControllerEditLinkRaw(requestParameters: LinksApiControllerEditLinkRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.linkId === null || requestParameters.linkId === undefined) {
            throw new runtime.RequiredError('linkId','Required parameter requestParameters.linkId was null or undefined when calling linksApiControllerEditLink.');
        }

        if (requestParameters.editLinkRequest === null || requestParameters.editLinkRequest === undefined) {
            throw new runtime.RequiredError('editLinkRequest','Required parameter requestParameters.editLinkRequest was null or undefined when calling linksApiControllerEditLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters.linkId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editLinkRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linksApiControllerEditLink(requestParameters: LinksApiControllerEditLinkRequest): Promise<void> {
        await this.linksApiControllerEditLinkRaw(requestParameters);
    }

    /**
     */
    async linksApiControllerExecuteActionRaw(requestParameters: LinksApiControllerExecuteActionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.linkId === null || requestParameters.linkId === undefined) {
            throw new runtime.RequiredError('linkId','Required parameter requestParameters.linkId was null or undefined when calling linksApiControllerExecuteAction.');
        }

        if (requestParameters.executeActionRequest === null || requestParameters.executeActionRequest === undefined) {
            throw new runtime.RequiredError('executeActionRequest','Required parameter requestParameters.executeActionRequest was null or undefined when calling linksApiControllerExecuteAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links/{linkId}:execute-action`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters.linkId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.executeActionRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linksApiControllerExecuteAction(requestParameters: LinksApiControllerExecuteActionRequest): Promise<void> {
        await this.linksApiControllerExecuteActionRaw(requestParameters);
    }

    /**
     */
    async linksApiControllerExecuteCampaignActionRaw(requestParameters: LinksApiControllerExecuteCampaignActionRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
            throw new runtime.RequiredError('campaignId','Required parameter requestParameters.campaignId was null or undefined when calling linksApiControllerExecuteCampaignAction.');
        }

        if (requestParameters.executeActionRequest === null || requestParameters.executeActionRequest === undefined) {
            throw new runtime.RequiredError('executeActionRequest','Required parameter requestParameters.executeActionRequest was null or undefined when calling linksApiControllerExecuteCampaignAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/campaigns/{campaignId}:execute-action`.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.executeActionRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linksApiControllerExecuteCampaignAction(requestParameters: LinksApiControllerExecuteCampaignActionRequest): Promise<void> {
        await this.linksApiControllerExecuteCampaignActionRaw(requestParameters);
    }

    /**
     * Public API
     */
    async linksApiControllerGetLinkRaw(requestParameters: LinksApiControllerGetLinkRequest): Promise<runtime.ApiResponse<GetLinkResponse>> {
        if (requestParameters.linkId === null || requestParameters.linkId === undefined) {
            throw new runtime.RequiredError('linkId','Required parameter requestParameters.linkId was null or undefined when calling linksApiControllerGetLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters.linkId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async linksApiControllerGetLink(requestParameters: LinksApiControllerGetLinkRequest): Promise<GetLinkResponse> {
        const response = await this.linksApiControllerGetLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async linksApiControllerPatchLinkRaw(requestParameters: LinksApiControllerPatchLinkRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.linkId === null || requestParameters.linkId === undefined) {
            throw new runtime.RequiredError('linkId','Required parameter requestParameters.linkId was null or undefined when calling linksApiControllerPatchLink.');
        }

        if (requestParameters.patchLinkRequest === null || requestParameters.patchLinkRequest === undefined) {
            throw new runtime.RequiredError('patchLinkRequest','Required parameter requestParameters.patchLinkRequest was null or undefined when calling linksApiControllerPatchLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/links/{linkId}`.replace(`{${"linkId"}}`, encodeURIComponent(String(requestParameters.linkId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchLinkRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async linksApiControllerPatchLink(requestParameters: LinksApiControllerPatchLinkRequest): Promise<void> {
        await this.linksApiControllerPatchLinkRaw(requestParameters);
    }

}
